
export const CONSIGNMENT_ITEM_KEY = 'consignment-item'

export const consignmentItemQueryKeys = {
  all: (params: { consignmentId: number | null; houseConsignmentId?: number }) => [CONSIGNMENT_ITEM_KEY, 'list', params],
  count: (params: { consignmentId: number | null; houseConsignmentId?: number }) => [CONSIGNMENT_ITEM_KEY, 'count', params],
  details: (id: number | null) => [CONSIGNMENT_ITEM_KEY, id],
}
